import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import GoLiveForm from "../components/goLiveForm/goLiveForm";
import withTracker from "./withtracker";
import { REGISTERED_USERS } from "../constants/userGroups";
import withBreadCrumb from "./withBreadcrumb";
import { getRouteUrl } from "../routers";
import Breadcrumb from "../components/breadcrumb/breadcrumb";
import { ROUTE_APPLICATION_VIEW } from "../routers/content/application";
import SectionStart from "../components/sectionStart/sectionStart";
import {
  Sidebar,
  SidebarHeader,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../components/layouts/layout1";
import Title from "../components/title/title";
import Heading from "../components/heading/heading";
import BracketButton from "../components/bracketButton/bracketButton";
import { useParams, useLocation } from "react-router-dom";
import AuthProvider from "../AuthProvider/AuthProvider";
import { updateUserTypeField } from "../authentication/actions";
import queryString from "query-string";

const GoLiveHOC = ({ breadcrumb }) => {
  let { applicationId } = useParams();
  const location = useLocation();
  const { organization } = queryString.parse(location.search);
  const dispatch = useDispatch();

  const userType = useSelector(
    ({ applicationUser }) => applicationUser?.userType
  );

  React.useEffect(() => {
    userType === "" && dispatch(updateUserTypeField(userType));
  }, []);

  return (
    <React.Fragment>
      <AuthProvider allowedRoles={REGISTERED_USERS}>
        <Breadcrumb
          {...breadcrumb}
          params={{
            app: {
              name: "Application",
              href: applicationId
                ? getRouteUrl(ROUTE_APPLICATION_VIEW, {
                    applicationId: applicationId,
                  })
                : null,
            },
          }}
        />

        <SectionStart>
          <SideBar>
            <SidebarLeft>
              <SidebarHeader>
                <Title type="section">
                  <Heading level="1" className="display-effect">
                    Go Live
                  </Heading>
                </Title>
                <BracketButton
                  caretEnable
                  className="movingBrackets left"
                  title={"BACK TO OVERVIEW"}
                  url={getRouteUrl(
                    ROUTE_APPLICATION_VIEW,
                    { applicationId: applicationId },
                    { organization: organization }
                  )}
                />
              </SidebarHeader>
            </SidebarLeft>
            <SidebarRight>
              <GoLiveForm
                userType={userType}
                applicationId={applicationId}
                organizationUuid={organization}
              />
            </SidebarRight>
          </SideBar>
        </SectionStart>
      </AuthProvider>
    </React.Fragment>
  );
};

export default withTracker(
  withBreadCrumb(GoLiveHOC, {
    name: "Go Live",
    parents: ["Apps", "{app}"],
  })
);
